/**
 * Pravidla rezervace + věrnostní program — hash route #pravidla.
 * Bod 10 ze schůzky 24.6.2026 (Sobáčov rezervační v2).
 */

export function Rules() {
  return (
    <section className="bg-gradient-to-b from-white to-steel-50/40 py-12 md:py-20">
      <div className="container-x max-w-3xl">
        {/* Eyebrow + nadpis */}
        <div>
          <div className="text-[10px] uppercase tracking-[0.30em] text-brand-500 font-bold flex items-center gap-2">
            <span className="inline-block w-8 h-px bg-brand-500" />
            Sobáčov · Fishing & Sport Resort
          </div>
          <h1 className="h-display text-4xl md:text-5xl mt-3">Pravidla rezervace</h1>
          <p className="text-ink-700 mt-3 text-sm">
            Sportoviště — tenisový kurt &amp; beach volejbal · platné od 1. 7. 2026
          </p>
        </div>

        {/* Karty pravidel */}
        <div className="mt-10 space-y-6">
          <Rule num="1" title="Co lze rezervovat online">
            <p><b>Tenisové kurty</b> (syntetický povrch) a <b>beach volejbalové hřiště</b> (písek), hodinové sloty od 9:00 do 21:00.</p>
            <p className="mt-2">
              Online lze max. <b>8 slotů z jednoho telefonu</b> — to znamená nejvýše <b>2 termíny v jednom dni</b> a <b>maximálně 4 různé dny dopředu</b>{' '}
              (tenis a beach volejbal se počítají dohromady).
            </p>
            <p className="mt-2">
              Pro pravidelnější rezervace nebo skupinové bloky volejte{' '}
              <a href="tel:+420775140705" className="text-brand-600 font-bold hover:underline">775 140 705</a> — dohodneme to ručně.
            </p>
          </Rule>

          <Rule num="2" title="Platba předem">
            <p>Cena se platí <b>100 % předem</b> přes platební bránu (karta · Apple Pay · Google Pay · QR · bankovní převod).</p>
            <p className="mt-2">Po vytvoření rezervace držíme termín <b>50 minut</b>. Pokud do té doby platba nedorazí, termín se automaticky uvolní.</p>
            <p className="mt-2">Po zaplacení dostaneš <b>potvrzovací SMS</b> s variabilním symbolem a podrobnostmi.</p>
          </Rule>

          <Rule num="3" title="Přesun termínu">
            <p>Termín lze přesunout nejpozději <b>24 hodin</b> před začátkem, a to <b>jednou</b> — z odkazu nebo kódu v potvrzovací SMS.</p>
            <p className="mt-2">Při přesunu se použije stejné sportoviště a stejná zaplacená cena.</p>
            <p className="mt-2 text-[12px] text-ink-700/80">Nebo můžeš na SMS odpovědět slovem <b>ZMENA</b> a náš robot ti pošle volby (přesun / voucher).</p>
          </Rule>

          <Rule num="4" title="Zrušení kvůli počasí" accent="forest">
            <p>Pokud zrušíme rezervaci kvůli nepříznivému počasí (silný déšť, mokrý povrch, bouřka):</p>
            <ul className="mt-2 space-y-1.5 text-ink-800 list-disc list-inside marker:text-forest-600">
              <li>Dostaneš <b className="text-forest-700">voucher 100 %</b> na další rezervaci stejného sportu.</li>
              <li>Voucher platí <b>90 dní</b>, uplatníš ho zadáním kódu při nové online rezervaci.</li>
              <li>Voucher nelze proplatit hotově.</li>
            </ul>
          </Rule>

          <Rule num="5" title="Věrnostní program · 5. rezervace zdarma" accent="forest">
            <p>Za každou zaplacenou sportovní rezervaci sbíráš body. Po <b>4 zaplacených</b> dostaneš automaticky <b className="text-forest-700">voucher 100 %</b> na 5. rezervaci.</p>
            <ul className="mt-2 space-y-1.5 text-ink-800 list-disc list-inside marker:text-forest-600">
              <li>Počítadlo běží napříč tenisem i beach volejbalem.</li>
              <li>Voucher dorazí SMS, uplatníš ho zadáním kódu při rezervaci.</li>
              <li>Platnost <b>180 dní</b>.</li>
            </ul>
          </Rule>

          <Rule num="6" title="Storno · žádné vracení peněz">
            <p>Sportovní rezervace je nevratná — <b>peníze nevracíme</b>, ať už ses rozhodl/a kdykoli před termínem.</p>
            <p className="mt-2">
              Jediná možnost je <b>přesun na náhradní termín</b> (viz bod 3) <b>nejpozději 24 hodin předem</b>.
              Když to nestihneš nebo se nedostavíš, slot propadá bez náhrady.
            </p>
            <p className="mt-2 text-[12px] text-ink-700/80">
              Pokud zrušíme my (počasí, technická závada), dostaneš voucher 100 % — viz bod 4.
            </p>
          </Rule>

          <Rule num="7" title="Pravidla na sportovišti">
            <ul className="space-y-1.5 text-ink-800 list-disc list-inside marker:text-brand-500">
              <li><b>Tenis</b> — pouze obuv vhodná pro syntetický povrch (žádné kolíky, hřebíky ani tretry, černé podrážky zanechávají stopy).</li>
              <li><b>Beach volejbal</b> — hraje se <b>bosky</b>, případně v lehkých plážových botách. Žádná obuv s pevnou podrážkou.</li>
              <li className="text-brand-700 font-semibold">
                ⚠️ <b>Přísný zákaz nošení skla</b> na sportoviště i do jeho okolí (nápoje, parfémy, brýle v pouzdře OK). Rozbité sklo v písku je nebezpečné a uzavře hřiště i o celé dny.
              </li>
              <li>Děti do 12 let pouze v doprovodu dospělé osoby.</li>
              <li>Půjčovna raket / míčů na recepci za poplatek, vratná záloha 500 Kč. Vybavení vracíš čisté.</li>
              <li>Hluk po <b>22:00</b> minimalizuj — kemp a chatky jsou cca 50 m od kurtů.</li>
              <li>Areál v CHKO Litovelské Pomoraví — nekuřácký, bez psů na sportovišti, bez ohně mimo grilovací místa.</li>
              <li>Úraz nebo poškození vybavení nahlas hned na recepci. Hra probíhá na vlastní nebezpečí.</li>
            </ul>
          </Rule>
        </div>

        {/* Kontakt blok */}
        <div className="mt-12 bg-gradient-to-br from-steel-800 to-steel-600 text-white p-6 md:p-8 relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-brand-500 to-brand-700" />
          <div className="absolute right-0 -bottom-16 -mr-16 w-48 h-48 rounded-full bg-brand-500/15 blur-2xl" />
          <div className="relative">
            <div className="text-[10px] uppercase tracking-[0.30em] text-brand-300 font-bold flex items-center gap-2">
              <span className="inline-block w-6 h-px bg-brand-400" />
              Kontakt
            </div>
            <h2 className="text-xl md:text-2xl font-bold tracking-tight mt-2">
              Sobáčov 111 · <span className="font-bold">783 21 Mladeč</span>
            </h2>
            <div className="mt-3 flex flex-wrap gap-3 text-sm">
              <a href="tel:+420775140705" className="bg-brand-500 hover:bg-brand-600 text-white px-4 py-2.5 font-bold uppercase tracking-[0.10em] text-[11px] shadow-lg shadow-brand-700/30 hover:shadow-brand-700/50 transition-shadow">
                +420 775 140 705
              </a>
              <a href="mailto:rezervace.sobacov@gmail.com" className="border border-white/40 hover:bg-white hover:text-ink-900 text-white px-4 py-2.5 font-bold tracking-[0.02em] text-[13px] transition-colors break-all">
                rezervace.sobacov@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <a href="#" className="text-ink-700 text-xs uppercase tracking-[0.10em] font-semibold hover:text-brand-500 transition-colors">
            ← Zpět na úvod
          </a>
        </div>
      </div>
    </section>
  )
}

function Rule({
  num, title, children, accent = 'brand',
}: {
  num: string
  title: string
  children: React.ReactNode
  accent?: 'brand' | 'forest'
}) {
  const ring = accent === 'forest' ? 'from-forest-50 to-white border-forest-200' : 'from-white to-brand-50/30 border-ink-900/10'
  const badge = accent === 'forest' ? 'bg-forest-600 text-white' : 'bg-brand-500 text-white'
  return (
    <div className={`relative bg-gradient-to-br ${ring} border p-5 md:p-6 shadow-sm hover:shadow-md transition-shadow`}>
      <div className="flex items-start gap-4">
        <div className={`shrink-0 w-9 h-9 ${badge} grid place-items-center font-bold text-sm shadow`}>
          {num}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-ink-900 text-lg leading-tight">{title}</h3>
          <div className="mt-2 text-ink-800 text-sm leading-relaxed">{children}</div>
        </div>
      </div>
    </div>
  )
}
